import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import { FormControl } from "react-bootstrap"
import { Validator } from "./ValidationResult";
import PropTypes from 'prop-types';

/**
 * This is a special control that is used as a surrogate form control for the purposes of value validation
 * @component
 */
export const HiddenValidationControl = forwardRef(({ value, style, ...props }, ref) => {
    const ctrlRef = useRef();
    const [checkValue, setCheckValue] = useState('');
    const [validity, setValidity] = useState();
    const initialValue = useRef(value);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        setValidity();
        setCheckValue(_ => {
            let checkValue = value;
            if (value !== null && value !== undefined) {
                if (Array.isArray(value) || typeof value === 'string') {
                    checkValue = value.length > 0 ? value.length : '';
                } else if (typeof value === 'boolean') {
                    checkValue = value ? 1 : 0;
                } else if (typeof value !== 'number' && typeof value !== 'bigint') {
                    checkValue = 1;
                }
            } else {
                checkValue = '';
            }

            if (value !== initialValue.current) {
                setDirty(true);
            } else {
                setDirty(false); // Reset dirty if value equals the initial value
            }

            return checkValue;
        })
    }, [value]);

    useEffect(() => {
        if (dirty) {
            setValidity(ctrlRef.current.checkValidity());
        } else {
            setValidity();
        }
    }, [checkValue, dirty]);

    useImperativeHandle(ref, () => ({
        checkValidity() { return ctrlRef.current?.checkValidity(); },
        addEventListener(...args) { 
            return ctrlRef.current?.addEventListener(...args)
        },
        removeEventListener(...args) {
            return ctrlRef.current?.removeEventListener(...args)
        },
        get validity() { return ctrlRef.current?.validity ?? {} }
    }), []);

    return <Validator value={value} ref={ctrlRef} onValidation={setValidity}>
        <FormControl isInvalid={validity === false} className="py-0 my-0" ref={ctrlRef} type="number" style={{ visibility: 'hidden', height: '0px', border: 'none', ...style }} value={checkValue} onInvalid={() => setValidity(false)} onChange={() => {}} {...props}></FormControl>
    </Validator>
})
HiddenValidationControl.propTypes = {
    /**
     * The value to be used for validation
     */
    value: PropTypes.any,
    /**
     * Custom styling - useful for debug purposes to expose the hidden control
     */
    style: PropTypes.object
}